interface NamePartial {
  firstName: string
  lastName: string
}

export const buildName = ({ firstName, lastName }: NamePartial) =>
  `${firstName} ${lastName}`
